/* eslint-disable no-restricted-globals */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable unicorn/prefer-query-selector */
/* eslint-disable unicorn/better-regex */
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { convertToBase64 } from "../../../../utils";
import {
  LocationEntity,
  UpdateLocationFormData,
} from "../../../../api/Locations";
import {
  Add,
  Clear,
  FileUpload,
  OpenInNew,
  Visibility,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectProfile } from "../../../../store/profile/selector";
import ConfirmationDialog from "../../../../shared/Components/ConfirmationDialog";
import PreviewDialog from "../../../../shared/Components/PreviewDialog";
import { useSnackbar } from "notistack";

interface Prop {
  defaultValue?: LocationEntity;
  onSubmit(payload: any): void;
}

export function LocationForm({ defaultValue, onSubmit }: Prop) {
  const profile = useSelector(selectProfile);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [validation, setValidation] = useState(false);
  const [formData, setFormData] = useState<UpdateLocationFormData>({
    binusianId: profile.binusianId,
    locationId: "",
    address: "",
    bmName: "",
    ext: "",
    email: "",
    locationName: "",
    manager: { name: "", phone: "", position: "" },
    mission: [""],
    personInCharge: [{ name: "", phone: "", position: "" }],
    phone: "",
    strategy: [""],
    vision: "",
    imageName: "",
    facebook: "",
    imageBase64: "",
    instagram: "",
    tiktok: "",
    youtube: "",
  });
  const [previewDialog, setPreviewDialog] = useState(false);

  const navigate = useNavigate();
  const snackbar = useSnackbar();

  const urlPattern =
    /^(https?:\/\/)?((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|(([0-9]{1,3}\.){3}[0-9]{1,3}))(:[0-9]{1,5})?(\/[-a-zA-Z0-9()@:%_+.~#?&/=]*)?(\?[;&a-zA-Z0-9%_+.~#?&/=]*)?(\#[-a-zA-Z0-9()@:%_+.~#?&/=]*)?$/i;

  useEffect(() => {
    if (defaultValue) {
      setFormData({
        binusianId: profile.binusianId,
        locationId: defaultValue.locationId,
        address: defaultValue.address,
        bmName: defaultValue.bmName,
        ext: defaultValue.ext,
        email: defaultValue.email,
        locationName: defaultValue.locationName,
        manager: defaultValue.manager,
        mission: defaultValue.mission,
        personInCharge: defaultValue.personInCharge,
        phone: defaultValue.phone,
        strategy: defaultValue.strategy,
        vision: defaultValue.vision,
        imageName: defaultValue.imageName,
        facebook: defaultValue.facebook || "",
        instagram: defaultValue.instagram || "",
        tiktok: defaultValue.tiktok || "",
        youtube: defaultValue.youtube || "",
      });
    }
  }, [defaultValue]);

  const handleFormData = (name: string, value: any) => {
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      handleFormData("imageName", file.name);
      await convertToBase64(file).then((res) =>
        handleFormData("imageBase64", res)
      );
    }
  };

  const handleButtonClick = () => {
    const fileInput = document.getElementById("file-input") as HTMLInputElement;
    fileInput.value = "";
    fileInput.click();
  };

  return (
    <Box className="flex flex-col w-full p-1 md:p-8 gap-10">
      <ConfirmationDialog
        description={`Are you sure you want to ${
          defaultValue ? "update" : "create"
        } this
            location?`}
        onCancel={() => setConfirmationDialog(false)}
        onClose={() => setConfirmationDialog(false)}
        open={confirmationDialog}
        onSubmit={() => {
          setConfirmationDialog(false);
          onSubmit(formData);
        }}
      />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography className="font-bold text-2xl">
            Location Details
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">Location Name</Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              value={formData.locationName}
              onChange={(e) => handleFormData("locationName", e.target.value)}
              error={validation && formData.locationName == ""}
              helperText={
                validation &&
                formData.locationName == "" &&
                "Location Name is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Address
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              value={formData.address}
              onChange={(e) => handleFormData("address", e.target.value)}
              error={validation && formData.address == ""}
              helperText={
                validation &&
                formData.address == "" &&
                "Building Management Address is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Name
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              value={formData.bmName}
              onChange={(e) => handleFormData("bmName", e.target.value)}
              error={validation && formData.bmName == ""}
              helperText={
                validation &&
                formData.bmName == "" &&
                "Building Management Name is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                File Upload Image Location BM
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <input
              id="file-input"
              type="file"
              accept=".jpg,.jpeg,.png"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <TextField
              value={formData.imageName}
              variant="outlined"
              disabled
              error={validation && formData.imageName == ""}
              helperText={
                validation &&
                formData.imageName == "" &&
                "Image Location BM is required!"
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box className="flex">
                      <Button
                        className="p-1 min-w-min"
                        onClick={handleButtonClick}
                      >
                        <FileUpload />
                      </Button>
                      <Button
                        className="p-1 min-w-min"
                        onClick={() => {
                          setPreviewDialog(true);
                        }}
                        disabled={formData.imageName == ""}
                      >
                        <Visibility />
                      </Button>
                      <Button
                        className="p-1 min-w-min"
                        onClick={() => {
                          handleFormData("imageName", "");

                          handleFormData("imageBase64", "");
                          const fileInput = document.getElementById(
                            "file-input"
                          ) as HTMLInputElement;
                          fileInput.value = "";
                        }}
                      >
                        <Clear />
                      </Button>
                    </Box>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} className="flex flex-col">
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Phone
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <Box className="flex gap-2">
              <TextField
                id="filled-basic"
                variant="outlined"
                className="w-full"
                value={formData.phone}
                onChange={(e) => handleFormData("phone", e.target.value)}
                error={validation && formData.phone == ""}
                helperText={
                  validation &&
                  formData.phone == "" &&
                  "Building Management Phone is required!"
                }
              />
            </Box>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Extension (Ext.)
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              value={formData.ext}
              onChange={(e) => handleFormData("ext", e.target.value)}
              error={validation && formData.ext == ""}
              helperText={
                validation &&
                formData.ext == "" &&
                "Building Management Extension is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Admin Email
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              value={formData.email}
              onChange={(e) => handleFormData("email", e.target.value)}
              error={validation && formData.email == ""}
              helperText={
                validation &&
                formData.email == "" &&
                "Building Management Admin Email is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={0} md={6} />
        <Grid item xs={12}>
          <Typography className="font-bold text-2xl">
            Personel Details
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Leader Name
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              value={formData.manager.name}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  manager: { ...prev.manager, name: e.target.value },
                }))
              }
              error={validation && formData.manager.name == ""}
              helperText={
                validation &&
                formData.manager.name == "" &&
                "Building Management Manager Name is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Leader Position
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <Box className="flex gap-2">
              <TextField
                id="filled-basic"
                variant="outlined"
                className="w-full"
                value={formData.manager.position}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    manager: { ...prev.manager, position: e.target.value },
                  }));
                }}
                error={validation && formData.manager.position == ""}
                helperText={
                  validation &&
                  formData.manager.position == "" &&
                  "Manager Position is required!"
                }
              />
            </Box>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} className="flex flex-col">
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Leader Phone
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              className="w-full"
              InputProps={{
                style: {
                  paddingLeft: 0,
                },
                startAdornment: (
                  <Box className="content-center p-3 text-white bg-primary-main rounded-md min-w-fit h-full mr-2">
                    <Typography>(62)</Typography>
                  </Box>
                ),
              }}
              value={formData.manager.phone}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  manager: { ...prev.manager, phone: e.target.value },
                }))
              }
              error={validation && formData.manager.phone == ""}
              helperText={
                validation &&
                formData.manager.phone == "" &&
                "Building Manager Phone is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={6} className="hidden md:block" />
        {formData.personInCharge.map((e, i) => (
          <>
            <Grid item xs={12} md={6}>
              <FormControl className="flex flex-col gap-4">
                <Box className="flex gap-2">
                  <Typography className="text-lg">
                    Building Management PIC {i + 1} Name
                  </Typography>
                  <Typography className="text-red-500">*</Typography>
                </Box>
                <TextField
                  id="filled-basic"
                  variant="outlined"
                  className="w-full"
                  value={e.name}
                  onChange={(el) => {
                    const picData = formData.personInCharge;
                    picData[i] = { ...picData[i], name: el.target.value };
                    setFormData((prev) => ({
                      ...prev,
                      personInCharge: picData,
                    }));
                  }}
                  error={validation && formData.personInCharge[i].name == ""}
                  helperText={
                    validation &&
                    formData.personInCharge[i].name == "" &&
                    "Building Management PIC name is required!"
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl className="flex flex-col gap-4">
                <Box className="flex gap-2">
                  <Typography className="text-lg">
                    Building Management PIC {i + 1} Position
                  </Typography>
                  <Typography className="text-red-500">*</Typography>
                </Box>
                <Box className="flex gap-2">
                  <TextField
                    id="filled-basic"
                    variant="outlined"
                    className="w-full"
                    value={e.position}
                    onChange={(el) => {
                      const picData = formData.personInCharge;
                      picData[i] = { ...picData[i], position: el.target.value };
                      setFormData((prev) => ({
                        ...prev,
                        personInCharge: picData,
                      }));
                    }}
                    error={
                      validation && formData.personInCharge[i].position == ""
                    }
                    helperText={
                      validation &&
                      formData.personInCharge[i].position == "" &&
                      "Building Management PIC Position is required!"
                    }
                  />
                  {formData.personInCharge.length > 1 && (
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => {
                        setFormData((prev) => {
                          const res = prev.personInCharge;
                          res.splice(i, 1);
                          return { ...prev, personInCharge: res };
                        });
                      }}
                    >
                      <Clear />
                    </Button>
                  )}
                </Box>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} className="flex flex-col">
              <FormControl className="flex gap-4">
                <Box className="flex gap-2">
                  <Typography className="text-lg">
                    Building Management PIC {i + 1} Phone
                  </Typography>
                  <Typography className="text-red-500">*</Typography>
                </Box>
                <TextField
                  id="filled-basic"
                  variant="outlined"
                  className="w-full"
                  InputProps={{
                    style: {
                      paddingLeft: 0,
                    },
                    startAdornment: (
                      <Box className="content-center p-3 text-white bg-primary-main rounded-md min-w-fit h-full mr-2">
                        <Typography>(62)</Typography>
                      </Box>
                    ),
                  }}
                  value={e.phone}
                  onChange={(el) => {
                    const picData = formData.personInCharge;
                    picData[i] = { ...picData[i], phone: el.target.value };
                    setFormData((prev) => ({
                      ...prev,
                      personInCharge: picData,
                    }));
                  }}
                  error={validation && formData.personInCharge[i].phone == ""}
                  helperText={
                    validation &&
                    formData.personInCharge[i].phone == "" &&
                    "Building Management PIC Phone is required!"
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={12}>
              {i + 1 == formData.personInCharge.length && i < 2 && (
                <Box
                  className="flex gap-2 justify-center md:justify-end items-center text-primary-main font-bold hover:cursor-pointer"
                  onClick={() => {
                    setFormData((prev) => {
                      const res = prev.personInCharge;
                      res.push({
                        name: "",
                        phone: "",
                        position: "",
                      });
                      return { ...prev, personInCharge: res };
                    });
                  }}
                >
                  <Button
                    size="small"
                    variant="contained"
                    className="p-1 min-w-min"
                  >
                    <Add />
                  </Button>
                  <Typography className="text-xs font-semibold">
                    Add other PIC; You can only add up to 3 PIC
                  </Typography>
                </Box>
              )}
            </Grid>
          </>
        ))}
        <Grid item xs={12} md={12}>
          <Typography className="font-bold text-2xl">
            About Us Details
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Building Management Site Vision Statement
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              className="w-full"
              value={formData.vision}
              onChange={(e) => handleFormData("vision", e.target.value)}
              error={validation && formData.vision == ""}
              helperText={
                validation && formData.vision == "" && "Vision is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={6} className="hidden md:block" />
        <Grid item xs={12} md={6}>
          <Box className="flex flex-col gap-4">
            {formData.mission.map((e, i) => (
              <Grid item xs={12}>
                <FormControl className="flex flex-col gap-4">
                  {i == 0 && (
                    <Box className="flex gap-2">
                      <Typography className="text-lg">
                        Building Management Site Mission Statement
                      </Typography>
                      <Typography className="text-red-500">*</Typography>
                    </Box>
                  )}
                  <Box className="flex gap-2">
                    <TextField
                      id="filled-basic"
                      variant="outlined"
                      className="w-full"
                      value={e}
                      onChange={(el) => {
                        setFormData((prev) => {
                          const res = prev.mission;
                          res[i] = el.target.value;
                          return {
                            ...prev,
                            mission: res,
                          };
                        });
                      }}
                      error={validation && formData.mission[i] == ""}
                      helperText={
                        validation &&
                        formData.mission[i] == "" &&
                        "Mission is required!"
                      }
                    />
                    {formData.mission.length > 1 && (
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          setFormData((prev) => {
                            const res = prev.mission;
                            res.splice(i, 1);
                            return { ...prev, mission: res };
                          });
                        }}
                      >
                        <Clear />
                      </Button>
                    )}
                  </Box>
                </FormControl>
                {i + 1 == formData.mission.length && i < 5 && (
                  <Box
                    className="flex gap-2 justify-center md:justify-end items-center text-primary-main font-bold mt-2 hover:cursor-pointer"
                    onClick={() => {
                      setFormData((prev) => {
                        const res = prev.mission;
                        res.push("");
                        return { ...prev, mission: res };
                      });
                    }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      className="p-1 min-w-min"
                    >
                      <Add />
                    </Button>
                    <Typography className="text-xs font-semibold">
                      Add Other Site Mission Statement
                    </Typography>
                  </Box>
                )}
              </Grid>
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box className="flex flex-col gap-4">
            {formData.strategy.map((e, i) => (
              <Grid item xs={12}>
                <FormControl className="flex flex-col gap-4">
                  {i == 0 && (
                    <Box className="flex gap-2">
                      <Typography className="text-lg">
                        Building Management Site Strategy Statement
                      </Typography>
                      <Typography className="text-red-500">*</Typography>
                    </Box>
                  )}
                  <Box className="flex gap-2">
                    <TextField
                      id="filled-basic"
                      variant="outlined"
                      className="w-full"
                      value={e}
                      onChange={(el) => {
                        setFormData((prev) => {
                          const res = prev.strategy;
                          res[i] = el.target.value;
                          return {
                            ...prev,
                            strategy: res,
                          };
                        });
                      }}
                      error={validation && formData.strategy[i] == ""}
                      helperText={
                        validation &&
                        formData.strategy[i] == "" &&
                        "Strategy is required!"
                      }
                    />
                    {formData.strategy.length > 1 && (
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          setFormData((prev) => {
                            const res = prev.strategy;
                            res.splice(i, 1);
                            return { ...prev, strategy: res };
                          });
                        }}
                      >
                        <Clear />
                      </Button>
                    )}
                  </Box>
                </FormControl>
                {i + 1 == formData.strategy.length && i < 5 && (
                  <Box
                    className="flex gap-2 justify-end items-center text-primary-main font-bold mt-2 hover:cursor-pointer"
                    onClick={() => {
                      setFormData((prev) => {
                        const res = prev.strategy;
                        res.push("");
                        return { ...prev, strategy: res };
                      });
                    }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      className="p-1 min-w-min"
                    >
                      <Add />
                    </Button>
                    <Typography className="text-xs font-semibold">
                      Add Other Site Strategy Statement
                    </Typography>
                  </Box>
                )}
              </Grid>
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography className="font-bold text-2xl">
            Social Media Details
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl className="flex flex-col gap-4">
                <Typography className="text-lg">Instagram Link</Typography>
                <Box className="flex">
                  <TextField
                    id="filled-basic"
                    variant="outlined"
                    InputProps={{
                      style: {
                        paddingRight: 0,
                      },
                      endAdornment: (
                        <Button
                          className="h-full ml-2"
                          variant="contained"
                          onClick={() => {
                            if (urlPattern.test(formData.instagram || "")) {
                              const toOpen = window.open(
                                formData.instagram,
                                "_blank",
                                "noopener,noreferrer"
                              );
                              if (toOpen) toOpen.opener = null;
                            } else {
                              snackbar.enqueueSnackbar(
                                "Please type a valid URL",
                                {
                                  variant: "error",
                                }
                              );
                            }
                          }}
                        >
                          <OpenInNew />
                        </Button>
                      ),
                    }}
                    error={
                      validation &&
                      formData.instagram !== "" &&
                      !urlPattern.test(formData.instagram || "")
                    }
                    helperText={
                      validation &&
                      formData.instagram !== "" &&
                      !urlPattern.test(formData.instagram || "") &&
                      "Please enter a valid URL."
                    }
                    value={formData.instagram}
                    onChange={(e) =>
                      handleFormData("instagram", e.target.value)
                    }
                  />
                </Box>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl className="flex flex-col gap-4">
                <Typography className="text-lg">Facebook Link</Typography>
                <Box className="flex">
                  <TextField
                    id="filled-basic"
                    variant="outlined"
                    InputProps={{
                      style: {
                        paddingRight: 0,
                      },
                      endAdornment: (
                        <Button
                          className="h-full ml-2"
                          variant="contained"
                          onClick={() => {
                            if (urlPattern.test(formData.facebook || "")) {
                              const toOpen = window.open(
                                formData.facebook,
                                "_blank",
                                "noopener,noreferrer"
                              );
                              if (toOpen) toOpen.opener = null;
                            } else {
                              snackbar.enqueueSnackbar(
                                "Please type a valid URL",
                                {
                                  variant: "error",
                                }
                              );
                            }
                          }}
                        >
                          <OpenInNew />
                        </Button>
                      ),
                    }}
                    error={
                      validation &&
                      formData.facebook !== "" &&
                      !urlPattern.test(formData.facebook || "")
                    }
                    helperText={
                      validation &&
                      formData.facebook !== "" &&
                      !urlPattern.test(formData.facebook || "") &&
                      "Please enter a valid URL."
                    }
                    value={formData.facebook}
                    onChange={(e) => handleFormData("facebook", e.target.value)}
                  />
                </Box>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl className="flex flex-col gap-4">
                <Typography className="text-lg">Tiktok Link</Typography>
                <Box className="flex">
                  <TextField
                    id="filled-basic"
                    variant="outlined"
                    InputProps={{
                      style: {
                        paddingRight: 0,
                      },
                      endAdornment: (
                        <Button
                          className="h-full ml-2"
                          variant="contained"
                          onClick={() => {
                            if (urlPattern.test(formData.tiktok || "")) {
                              const toOpen = window.open(
                                formData.tiktok,
                                "_blank",
                                "noopener,noreferrer"
                              );
                              if (toOpen) toOpen.opener = null;
                            } else {
                              snackbar.enqueueSnackbar(
                                "Please type a valid URL",
                                {
                                  variant: "error",
                                }
                              );
                            }
                          }}
                        >
                          <OpenInNew />
                        </Button>
                      ),
                    }}
                    error={
                      validation &&
                      formData.tiktok !== "" &&
                      !urlPattern.test(formData.tiktok || "")
                    }
                    helperText={
                      validation &&
                      formData.tiktok !== "" &&
                      !urlPattern.test(formData.tiktok || "") &&
                      "Please enter a valid URL."
                    }
                    value={formData.tiktok}
                    onChange={(e) => handleFormData("tiktok", e.target.value)}
                  />
                </Box>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl className="flex flex-col gap-4">
                <Typography className="text-lg">Youtube Link</Typography>
                <Box className="flex w-full">
                  <TextField
                    id="filled-basic"
                    variant="outlined"
                    InputProps={{
                      style: {
                        paddingRight: 0,
                      },
                      endAdornment: (
                        <Button
                          className="h-full ml-2"
                          variant="contained"
                          onClick={() => {
                            if (urlPattern.test(formData.youtube || "")) {
                              const toOpen = window.open(
                                formData.youtube,
                                "_blank",
                                "noopener,noreferrer"
                              );
                              if (toOpen) toOpen.opener = null;
                            } else {
                              snackbar.enqueueSnackbar(
                                "Please type a valid URL",
                                {
                                  variant: "error",
                                }
                              );
                            }
                          }}
                        >
                          <OpenInNew />
                        </Button>
                      ),
                    }}
                    error={
                      validation &&
                      formData.youtube !== "" &&
                      !urlPattern.test(formData.youtube || "")
                    }
                    helperText={
                      validation &&
                      formData.youtube !== "" &&
                      !urlPattern.test(formData.youtube || "") &&
                      "Please enter a valid URL."
                    }
                    value={formData.youtube}
                    onChange={(e) => handleFormData("youtube", e.target.value)}
                  />
                </Box>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box className="flex justify-center gap-5 mt-10">
        <Button
          variant="contained"
          className="capitalize py-3 px-10 text-lg"
          size="large"
          onClick={() => navigate("/master-location")}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          className="capitalize py-3 px-10 text-lg"
          size="large"
          onClick={() => {
            if (
              formData.address == "" ||
              formData.bmName == "" ||
              formData.ext == "" ||
              formData.email == "" ||
              formData.imageName == "" ||
              formData.locationName == "" ||
              formData.manager.name == "" ||
              formData.manager.phone == "" ||
              formData.manager.position == "" ||
              formData.phone == "" ||
              formData.vision == "" ||
              formData.personInCharge.some((item) => item.name === "") ||
              formData.personInCharge.some((item) => item.phone === "") ||
              formData.personInCharge.some((item) => item.position === "") ||
              formData.mission.includes("") ||
              formData.strategy.includes("") ||
              (formData.instagram !== "" &&
                !urlPattern.test(formData.instagram || "")) ||
              (formData.facebook !== "" &&
                !urlPattern.test(formData.facebook || "")) ||
              (formData.tiktok !== "" &&
                !urlPattern.test(formData.tiktok || "")) ||
              (formData.youtube !== "" &&
                !urlPattern.test(formData.youtube || ""))
            ) {
              setValidation(true);
            } else {
              setConfirmationDialog(true);
            }
          }}
        >
          Save
        </Button>
      </Box>
      <PreviewDialog
        open={previewDialog}
        onClose={() => setPreviewDialog(false)}
        imageBase64={formData.imageBase64}
        imageUrl={defaultValue?.imageUrl}
        title={formData.imageName}
      />
    </Box>
  );
}
